import { of } from "rxjs";
import { tap, ignoreElements } from "rxjs/operators";
import { ofType, combineEpics } from "redux-observable";
import { getCompletedAsyncWrapperObj } from "@ane/core/lib/models";
import { produceLoadLoadingLoadedEpic } from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import NavigationService from "@ane/core/lib/services/NavigationService";
import { createComputeActionTypes, creatingCompute, createdCompute, updateComputeActionTypes, updatingCompute, updatedCompute } from "./ComputeCreateContainer.ducks.js";
import ComputeResource from "../../../../Compute.resource.js";
import { convertToComputePostParams } from "../CreateWizard/ComputeCreateFormSettings.js";
import { ComputeRouteUtils } from "@ane/exp-data/lib/routes/ComputeRoute.utils";
const createComputeEpic = produceLoadLoadingLoadedEpic({
  filterOnType: createComputeActionTypes.LOAD,
  loadResource: (payload) => {
    let computePost = convertToComputePostParams(payload);
    return ComputeResource.postCompute(computePost);
  },
  loadingAction: (payload) => creatingCompute(),
  loadedAction: (successData, payload, error) => {
    return of(createdCompute(getCompletedAsyncWrapperObj(successData, error)));
  }
});
const afterCreateCompute = (action$) => {
  return action$.pipe(
    ofType(createComputeActionTypes.LOADED),
    tap((action) => {
      let postParams = action.payload.createCompute.data;
      if (!!postParams && !!postParams.name && postParams.workspaceId) {
        NavigationService.navigateTo(ComputeRouteUtils.routes.root.getURL());
      }
    }),
    ignoreElements()
  );
};
const updateComputeEpic = produceLoadLoadingLoadedEpic({
  filterOnType: updateComputeActionTypes.LOAD,
  loadResource: (payload) => {
    let computePost = convertToComputePostParams(payload);
    return ComputeResource.putCompute(computePost);
  },
  loadingAction: (payload) => updatingCompute(),
  loadedAction: (successData, payload, error) => {
    return of(updatedCompute(getCompletedAsyncWrapperObj(successData, error)));
  }
});
const ComputeCreateEpic = combineEpics(createComputeEpic, afterCreateCompute, updateComputeEpic);
export {
  afterCreateCompute,
  createComputeEpic,
  ComputeCreateEpic as default,
  updateComputeEpic
};
//# sourceMappingURL=ComputeCreateContainer.epic.js.map
